import { Button, Flex, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import List from './List';

const Blog = () => {
  const navigate = useNavigate();
  return (
    <Flex flexDirection='column'>
      <Flex justifyContent='space-between'>
        <Heading>Blog Posts</Heading>
        <Flex alignItems='flex-end' gap='10px'>
          <Button onClick={() => navigate('/blog/add')}>+ Add New Post</Button>
        </Flex>
      </Flex>
      <List />
    </Flex>
  );
};

export default Blog;
